import { render, staticRenderFns } from "./ModificadoresCRUD.vue?vue&type=template&id=46f6aeef"
import script from "./ModificadoresCRUD.vue?vue&type=script&lang=js"
export * from "./ModificadoresCRUD.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports